import { render, staticRenderFns } from "./myStock.vue?vue&type=template&id=2e42c79e"
import script from "./myStock.vue?vue&type=script&lang=js"
export * from "./myStock.vue?vue&type=script&lang=js"
import style0 from "./myStock.vue?vue&type=style&index=0&id=2e42c79e&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports